<nav class="col-md-2 d-none d-md-block bg-light d-print-none" id="sidebar">
    <div class="sidebar-sticky">
        <ul class="nav justify-content-center flex-column">
            <li class="nav-item text-center">
                <img [src]="'assets/images/papin-rent-a-bike-logo.png'" class="img-fluid" width="150" />
            </li>
        </ul>
        <hr style="margin-bottom: 0px;" />
        <ul class="nav justify-content-center">
            <li class="nav-item">
                <button (click)="switchLanguage('en')" class="btn btn-link" style="background-image: url('../../../../assets/flag/uk.png'); width: 24px; height: 24px; margin: 10px"></button>
            </li>
            <li class="nav-item">
                <button (click)="switchLanguage('de')" class="btn btn-link" style="background-image: url('../../../../assets/flag/de.png'); width: 24px; height: 24px; margin: 10px"></button>
            </li>
            <li class="nav-item">
                <button (click)="switchLanguage('it')" class="btn btn-link" style="background-image: url('../../../../assets/flag/it.png'); width: 24px; height: 24px; margin: 10px"></button>
            </li>
        </ul>
        <hr style="margin-top: 0px;" />
        <app-nav-items-group *ngFor="let menuGroup of menuItems" [menuGroup]="menuGroup" [accessRightsArray]="accessRightsArray"></app-nav-items-group>
    </div>
</nav>
